export const TRACKING_ID = 'UA-128940841-1';

type State = {
  queue: {
    name: string;
    params: unknown[];
  }[];
};

const state: State = {
  queue: [],
};

export const loadScript = () => {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
  if (window.gtag) {
    return;
  }
  const scriptTag = document.createElement('script');
  scriptTag.async = true;
  scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`;
  document.head.appendChild(scriptTag);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'dataLayer' does not exist on type 'Windo... Remove this comment to see the full error message
  window.dataLayer = window.dataLayer || [];
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
  window.gtag = function gtag() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'dataLayer' does not exist on type 'Windo... Remove this comment to see the full error message
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
  window.gtag('js', new Date());
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
  window.gtag('config', `${TRACKING_ID}`, { anonymize_ip: true, send_page_view: false });

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'granted',
  });

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
  state.queue.forEach(({ params }) => window.gtag(...params));
};

export const updateConsent = () => {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
  window.gtag('consent', 'update', {
    ad_storage: 'granted',
    analytics_storage: 'granted',
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageView = (url: string) => {
  const args = [
    'event',
    'page_view',
    {
      page_path: url,
    },
  ];
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
  if (window.gtag) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
    return window.gtag(...args);
  }
  state.queue.push({ name: 'pageView', params: args });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({
  action,
  category,
  label,
  value,
}: {
  action: unknown;
  category: unknown;
  label: unknown;
  value: unknown;
}) => {
  const args = [
    'event',
    action,
    {
      event_category: category,
      event_label: label,
      value: value,
    },
  ];
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
  if (window.gtag) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'gtag' does not exist on type 'Window & t... Remove this comment to see the full error message
    return window.gtag(...args);
  }
  state.queue.push({ name: 'event', params: args });
};

const beginCheckout = ({
  affiliation,
  variant,
  id,
  name,
  category,
}: {
  affiliation?: string;
  variant?: string;
  id: string;
  name: string;
  category: string;
}) => {
  const args = [
    'event',
    'begin_checkout',
    {
      items: [
        {
          item_id: id,
          item_name: name,
          item_brand: 'Milkywire',
          item_category: category,
          item_variant: variant,
          index: 1,
          quantity: 0,
          affiliation,
        },
      ],
    },
  ];
  // @ts-expect-error
  if (window.gtag) {
    // @ts-expect-error
    return window.gtag(...args);
  }
  state.queue.push({ name: 'beginCheckout', params: args });
};

const purchase = ({
  amount,
  currency,
  transactionId,
  affiliation,
  variant,
  id,
  name,
  category,
}: {
  amount: number;
  currency: string;
  transactionId: string;
  affiliation?: string;
  variant?: string;
  id: string;
  name: string;
  category: string;
}) => {
  const args = [
    'event',
    'purchase',
    {
      transaction_id: transactionId,
      value: amount,
      currency,
      tax: 0,
      shipping: 0,
      items: [
        {
          item_id: id,
          item_name: name,
          item_brand: 'Milkywire',
          item_category: category,
          item_variant: variant,
          index: 1,
          quantity: 1,
          price: amount,
          affiliation,
        },
      ],
    },
  ];
  // @ts-expect-error
  if (window.gtag) {
    // @ts-expect-error
    return window.gtag(...args);
  }
  state.queue.push({ name: 'purchase', params: args });
};

export const beginCheckoutGift = ({ affiliation }: { affiliation?: string }) => {
  return beginCheckout({
    affiliation,
    id: 'gift',
    name: 'Milkywire Gift',
    category: 'gifts',
  });
};

export const giftPurchase = ({
  amount,
  currency,
  paymentFlowId,
  affiliation,
  variant,
}: {
  amount: number;
  currency: string;
  paymentFlowId: string;
  affiliation?: string;
  variant: string;
}) => {
  return purchase({
    amount,
    currency,
    transactionId: paymentFlowId,
    affiliation,
    variant,
    id: 'gift',
    name: 'Milkywire Gift',
    category: 'gifts',
  });
};

export const beginCheckoutOneTime = ({ affiliation }: { affiliation?: string }) => {
  return beginCheckout({
    affiliation,
    id: 'one-time',
    name: 'Milkywire One-Time Donation',
    category: 'one-times',
  });
};

export const oneTimePurchase = ({
  amount,
  currency,
  paymentFlowId,
  affiliation,
}: {
  amount: number;
  currency: string;
  paymentFlowId: string;
  affiliation?: string;
}) => {
  return purchase({
    amount,
    currency,
    transactionId: String(paymentFlowId),
    affiliation,
    id: 'one-time',
    name: 'Milkywire One-Time Donation',
    category: 'one-times',
  });
};

export const beginCheckoutSubscription = () => {
  return beginCheckout({
    id: 'subscription',
    name: 'Milkywire Recurring Donation',
    category: 'subscriptions',
  });
};

export const subscriptionPurchase = ({
  amount,
  currency,
  paymentFlowId,
  affiliation,
}: {
  amount: number;
  currency: string;
  paymentFlowId: string;
  affiliation?: string;
}) => {
  return purchase({
    amount,
    currency,
    transactionId: paymentFlowId,
    affiliation,
    id: 'subscription',
    name: 'Milkywire Recurring Donation',
    category: 'subscriptions',
  });
};
